// Facility address mapping for NY Correctional Facilities
window.facilityAddresses = {
  "Adirondack Correctional Facility": {
    address: "196 Ray Brook Road",
    city: "Ray Brook",
    state: "NY",
    zip: "12977"
  },
  "Albion Correctional Facility": {
    address: "3595 State School Road",
    city: "Albion",
    state: "NY",
    zip: "14411"
  },
  "Altona Correctional Facility": {
    address: "555 Devils Den Road",
    city: "Altona",
    state: "NY",
    zip: "12910"
  },
  "Attica Correctional Facility": {
    address: "639 Exchange Street",
    city: "Attica",
    state: "NY",
    zip: "14011"
  },
  "Auburn Correctional Facility": {
    address: "135 State Street",
    city: "Auburn",
    state: "NY",
    zip: "13024"
  },
  "Bare Hill Correctional Facility": {
    address: "181 Brand Road",
    city: "Malone",
    state: "NY",
    zip: "12953"
  },
  "Bedford Hills Correctional Facility": {
    address: "247 Harris Road",
    city: "Bedford Hills",
    state: "NY",
    zip: "10507"
  },
  "Cape Vincent Correctional Facility": {
    address: "36043 NYS Route 12E",
    city: "Cape Vincent",
    state: "NY",
    zip: "13618"
  },
  "Cayuga Correctional Facility": {
    address: "2202 State Route 38",
    city: "Moravia",
    state: "NY",
    zip: "13118"
  },
  "Clinton Correctional Facility": {
    address: "1156 Route 374",
    city: "Dannemora",
    state: "NY",
    zip: "12929"
  },
  "Collins Correctional Facility": {
    address: "Middle Road",
    city: "Collins",
    state: "NY",
    zip: "14034"
  },
  "Coxsackie Correctional Facility": {
    address: "11260 Route 9W",
    city: "Coxsackie",
    state: "NY",
    zip: "12051"
  },
  "Downstate Correctional Facility": {
    address: "121 Red Schoolhouse Road",
    city: "Fishkill",
    state: "NY",
    zip: "12524"
  },
  "Eastern Correctional Facility": {
    address: "30 Institution Road",
    city: "Napanoch",
    state: "NY",
    zip: "12458"
  },
  "Elmira Correctional Facility": {
    address: "1879 Davis Street",
    city: "Elmira",
    state: "NY",
    zip: "14901"
  },
  "Fishkill Correctional Facility": {
    address: "271 Matteawan Road",
    city: "Beacon",
    state: "NY",
    zip: "12508"
  },
  "Five Points Correctional Facility": {
    address: "6600 State Route 96",
    city: "Romulus",
    state: "NY",
    zip: "14541"
  },
  "Franklin Correctional Facility": {
    address: "62 Bare Hill Road",
    city: "Malone",
    state: "NY",
    zip: "12953"
  },
  "Gouverneur Correctional Facility": {
    address: "112 Scotch Settlement Road",
    city: "Gouverneur",
    state: "NY",
    zip: "13642"
  },
  "Great Meadow Correctional Facility": {
    address: "11739 State Route 22",
    city: "Comstock",
    state: "NY",
    zip: "12821"
  },
  "Green Haven Correctional Facility": {
    address: "594 Route 216",
    city: "Stormville",
    state: "NY",
    zip: "12582"
  },
  "Greene Correctional Facility": {
    address: "165 Plank Road",
    city: "Coxsackie",
    state: "NY",
    zip: "12051"
  },
  "Groveland Correctional Facility": {
    address: "7000 Sonyea Road",
    city: "Sonyea",
    state: "NY",
    zip: "14556"
  },
  "Hale Creek Asactc Correctional Facility": {
    address: "279 Maloney Road",
    city: "Johnstown",
    state: "NY",
    zip: "12095",
    shipping_name: "Hale Creek ASACTC CF"
  },
  "Hudson Correctional Facility": {
    address: "50 East Court Street",
    city: "Hudson",
    state: "NY",
    zip: "12534"
  },
  "Lakeview Shock Incarceration Correctional Facility": {
    address: "9300 Lake Avenue",
    city: "Brocton",
    state: "NY",
    zip: "14716",
    shipping_name: "Lakeview Shock Incarceration CF"
  },
  "Marcy Correctional Facility": {
    address: "9000 Old River Road",
    city: "Marcy",
    state: "NY",
    zip: "13403"
  },
  "Midstate Correctional Facility": {
    address: "9005 Old River Road",
    city: "Marcy",
    state: "NY",
    zip: "13403"
  },
  "Mohawk Correctional Facility": {
    address: "6514 State Route 26",
    city: "Rome",
    state: "NY",
    zip: "13442"
  },
  "Moriah Shock Incarceration Correctional Facility": {
    address: "985 Ensign Pond Road",
    city: "Mineville",
    state: "NY",
    zip: "12956"
  },
  "Ogdensburg Correctional Facility": {
    address: "One Correction Way",
    city: "Ogdensburg",
    state: "NY",
    zip: "13669"
  },
  "Orleans Correctional Facility": {
    address: "3531 Gaines Basin Road",
    city: "Albion",
    state: "NY",
    zip: "14411"
  },
  "Otisville Correctional Facility": {
    address: "57 Sanitorium Road",
    city: "Otisville",
    state: "NY",
    zip: "10963"
  },
  "Riverview Correctional Facility": {
    address: "850 Water Street",
    city: "Ogdensburg",
    state: "NY",
    zip: "13669"
  },
  "Shawangunk Correctional Facility": {
    address: "200 Quick Road",
    city: "Wallkill",
    state: "NY",
    zip: "12589"
  },
  "Sing Sing Correctional Facility": {
    address: "354 Hunter Street",
    city: "Ossining",
    state: "NY",
    zip: "10562"
  },
  "Southport Correctional Facility": {
    address: "236 Bob Masia Drive",
    city: "Pine City",
    state: "NY",
    zip: "14871"
  },
  "Sullivan Correctional Facility": {
    address: "325 Riverside Drive",
    city: "Fallsburg",
    state: "NY",
    zip: "12733"
  },
  "Taconic Correctional Facility": {
    address: "250 Harris Road",
    city: "Bedford Hills",
    state: "NY",
    zip: "10507"
  },
  "Ulster Correctional Facility": {
    address: "750 Berme Road",
    city: "Napanoch",
    state: "NY",
    zip: "12458"
  },
  "Upstate Correctional Facility": {
    address: "309 Bare Hill Road",
    city: "Malone",
    state: "NY",
    zip: "12953"
  },
  "Wallkill Correctional Facility": {
    address: "110 Burroughs Drive",
    city: "Wallkill",
    state: "NY",
    zip: "12589"
  },
  "Washington Correctional Facility": {
    address: "72 Lock 11 Lane",
    city: "Comstock",
    state: "NY",
    zip: "12821"
  },
  "Wende Correctional Facility": {
    address: "3040 Wende Road",
    city: "Alden",
    state: "NY",
    zip: "14004"
  },
  "Willard Drug Treatment": {
    address: "7116 County Route 132",
    city: "Willard",
    state: "NY",
    zip: "14588"
  },
  "Woodbourne Correctional Facility": {
    address: "99 Prison Road",
    city: "Woodbourne",
    state: "NY",
    zip: "12788"
  },
  "Wyoming Correctional Facility": {
    address: "3203 Dunbar Road",
    city: "Attica",
    state: "NY",
    zip: "14011"
  }
};